export const environment = {
    production: false,
    // Area1
    // serviceBaseUrl: 'https://gw.env.eurofins.fr/GSPrelevementUAT/',
    // launcherUrl: 'https://launcheruat.env.eurofins.fr/',

    // ETFR
    serviceBaseUrl: 'https://apigw.etfr.eurofins.com/GSPrelevementUAT/server/',
    launcherUrl: 'https://launcheruat.etfr.eurofins.com/',
    appName: 'GSp UAT',
    appCode: 'APP0000037',
    name: 'UAT'
};
